// extracted by mini-css-extract-plugin
export var rating = "Rating-module--rating--2E-ZY";
export var item = "Rating-module--item--2qYiT";
export var icon = "Rating-module--icon--35NtU";
export var ratingOnBackground = "Rating-module--ratingOnBackground--AKpvn";
export var rating1 = "Rating-module--rating1--3IKtx";
export var rating2 = "Rating-module--rating2--ei55R";
export var rating3 = "Rating-module--rating3--1Wrbe";
export var rating4 = "Rating-module--rating4--11P91";
export var rating5 = "Rating-module--rating5--1m8qQ";
export var show = "Rating-module--show--1lPJf";
export var showFadeInDown = "Rating-module--show-fade-in-down--1Ii3o";
export var showFadeInUp = "Rating-module--show-fade-in-up--2ys6q";
export var hideFadeOut = "Rating-module--hide-fade-out--xlLvn";